module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_11.ea247404dd2acc9339549f27b9ed5639.png";